import React from 'react'
import MailboxSelector from 'pages/main/components/MailboxSelector'

import i18n from 'i18n'
import classNames from 'classnames'
import { getTempEnvParam, setTempEnvParam } from 'env'

import dataManager from 'pages/main/data/DataManager'

import {
  confirmBase,
  // dragPopup
} from 'utils/ui'

interface SelectFolderOptions {
  title?: string
  okText?: string
  tabs?: any
  hideTabs?: boolean
  except?: any
  exceptRole?: any
  enableRoot?: any
  onSelect?: (key: any, mailbox: any) => void
}

export default function openSelectFolder(options?: SelectFolderOptions): void {
  const opts = options || {}

  const tmpObj: any = {
    title: opts.title || i18n.t('email.title.moveFolder'),
    okText: opts.okText || i18n.t('common.button.move'),
    tabs: opts.tabs,
    btnDisabled: true,
    saveLoading: false,
    curTab: getTempEnvParam('mailboxSelector.defaultActiveKey') || 'folders',
  }

  if (options?.except != null) {
    tmpObj.except = options.except
  }

  if (options?.exceptRole != null) {
    tmpObj.exceptRole = options.exceptRole
  }

  if (options?.enableRoot != null) {
    tmpObj.enableRoot = options.enableRoot
  }

  tmpObj.setMoveBtnState = ({
    disabled,
    loading,
  }: {
    disabled: boolean
    loading: boolean
  }): void => {
    tmpObj.btnDisabled = disabled
    tmpObj.saveLoading = loading
    tmpObj.updateModal()
  }

  tmpObj.onSelectItem = (item: any): void => {
    tmpObj.selectedItem = item

    tmpObj.setMoveBtnState({
      disabled: tmpObj.selectedItem == null,
      loading: false,
    })
  }

  tmpObj.onTabChange = (activeKey: string): void => {
    tmpObj.curTab = activeKey
  }

  tmpObj.appendRecentList = (mailboxId: any): void => {
    dataManager.addRecentMoveMailboxId(mailboxId)
  }

  tmpObj.notifySelect = (): void => {
    if (tmpObj.selectedItem != null) {
      const mailbox = tmpObj.selectedItem
      const key = mailbox.getId()

      tmpObj.appendRecentList(key)

      if (opts.onSelect != null) {
        opts.onSelect(key, mailbox)
      }
    }
  }

  tmpObj.render = (): React.ReactElement => {
    const attrs = {
      owner: tmpObj,
      tabs: tmpObj.tabs,
      hideTabs: opts.hideTabs,
      onSelectItem: tmpObj.onSelectItem,
      onTabChange: tmpObj.onTabChange,
      except: tmpObj.except,
      exceptRole: tmpObj.exceptRole,
      enableRoot: tmpObj.enableRoot,
      defaultActiveKey: tmpObj.curTab,
    }
    return <MailboxSelector {...attrs} />
  }

  tmpObj.modalObj = confirmBase({
    wrapClassName: classNames('folderModal'),
    title: tmpObj.title,
    content: tmpObj.render(),
    okText: tmpObj.okText,
    okButtonProps: {
      className: classNames('type1', 'h38', 'w100'),
      disabled: tmpObj.btnDisabled,
    },
    onOk: (closeFunc: () => void): void => {
      setTempEnvParam('mailboxSelector.defaultActiveKey', tmpObj.curTab)
      tmpObj.notifySelect()
      tmpObj.onSelectItem(null)
      closeFunc()
    },
    // afterClose: () => {
    //   tmpObj.dragPopup.removeEvent();
    // }
  })

  // tmpObj.dragPopup = dragPopup(tmpObj);

  tmpObj.updateModal = (): void => {
    tmpObj.modalObj.updateBase({
      content: tmpObj.render(),
      okButtonProps: {
        className: classNames('type1', 'h38', 'w100'),
        disabled: tmpObj.btnDisabled,
        loading: tmpObj.saveLoading,
      },
    })
  }
}
